/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const DirectiveSource = zod.enum(['builtin', 'custom']);

export type DirectiveSource = zod.input<typeof DirectiveSource>;
export type DirectiveSourceOutput = zod.output<typeof DirectiveSource>;
